import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import type { PublicKeyAuthAction, PublicKeyAuthMethod } from '../types'

export type AuthView =
  'signin' | 'signup' | 'forgot-password' | `${PublicKeyAuthMethod}-${PublicKeyAuthAction}`

interface AuthDialogState {
  isOpen: boolean
  view: AuthView
  onSuccess: (() => void) | null
  open: (view: AuthView, onSuccess?: () => void) => void
  close: () => void
  switchView: (view: AuthView) => void
}

export const useAuthDialogStore = create<AuthDialogState>()(
  devtools(
    (set) => ({
      isOpen: false,
      view: 'signin',
      onSuccess: null,
      open: (view, onSuccess) => set({ isOpen: true, view, onSuccess: onSuccess || null }),
      close: () => set({ isOpen: false, onSuccess: null }),
      switchView: (view) => set({ view }),
    }),
    { name: 'auth-dialog-store' }
  )
)
